import { ConfigurationType, LineSetType } from 'data/types';

export const LINESET_DEFAULT_COLOR = 0x000000;

export const LINESET_SELECTED_HANDLE_COLOR = 0x2563eb;

export const LINESET_HANDLE_HOVER_TINT = 0.35;

export const CONDENSER_LINESET_COLORS: readonly number[] = [
  0xdc2626, 0x1e40af, 0xea580c, 0x7c3aed, 0x0d9488, 0xdb2777, 0xca8a04,
  0x4f46e5, 0x65a30d, 0x0891b2, 0xe11d48, 0x9333ea
];

export function getCondenserLinesetColor(condenserIndex: number): number {
  if (condenserIndex < 0) return LINESET_DEFAULT_COLOR;
  return CONDENSER_LINESET_COLORS[
    condenserIndex % CONDENSER_LINESET_COLORS.length
  ];
}

export function getLinesetHandleHoverColor(color: number): number {
  const [red, green, blue] = [0x10000, 0x100, 1].map((channelScale) => {
    const channel = Math.floor(color / channelScale) % 0x100;
    return Math.round(channel + (0xff - channel) * LINESET_HANDLE_HOVER_TINT);
  });
  return red * 0x10000 + green * 0x100 + blue;
}

export function resolveLinesetColor(
  lineset: Pick<LineSetType, 'condenserUniqueId'>,
  configuration: Pick<ConfigurationType, 'condensers'> | undefined,
  colorByCondenser: boolean
): number {
  if (!colorByCondenser || !configuration) return LINESET_DEFAULT_COLOR;
  const condenserIndex = configuration.condensers.findIndex(
    (condenser) => condenser.uniqueId === lineset.condenserUniqueId
  );
  return getCondenserLinesetColor(condenserIndex);
}
